document.addEventListener("DOMContentLoaded", () => {
  function setupPopup(openBtnSelector, popupSelector) {
    const openBtn = document.querySelector(openBtnSelector);
    const popup = document.querySelector(popupSelector);
    if (!popup) return;

    const container = popup.querySelector("div");

    const forceClose = (selector) => {
      const p = document.querySelector(selector);
      if (p && p.classList.contains("show")) {
        p.classList.remove("show", "closing");
      }
    };

    const open = () => {
      if (popupSelector === ".thankyou-popup") {
        forceClose(".form-holding-popup");
      }
      popup.classList.remove("closing");
      popup.classList.add("show");
      document.body.style.overflow = "hidden";
    };

    const close = () => {
      popup.classList.add("closing");
      container.addEventListener(
        "transitionend",
        () => {
          popup.classList.remove("show", "closing");
          document.body.style.overflow = "";
        },
        { once: true }
      );
    };

    openBtn?.addEventListener("click", open);
    popup.addEventListener("click", (e) => {
      if (e.target === popup || e.target.closest(".close_btn")) close();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && popup.classList.contains("show")) close();
    });
  }

  setupPopup("#join_btn", ".form-holding-popup");
  setupPopup("#thankyou_pop_show_btn", ".thankyou-popup");
});

const observer = new MutationObserver(() => {
  const svgImage = document.querySelector(
    ".form-holding-popup-container svg image"
  );

  if (!svgImage || document.querySelector(".popup-controlled-img")) return;

  const imgUrl =
    svgImage.getAttribute("href") ||
    svgImage.getAttributeNS("http://www.w3.org/1999/xlink", "href");

  if (!imgUrl) return;

  const img = document.createElement("img");
  img.src = imgUrl;
  img.alt = "Popup image";
  img.className = "popup-controlled-img";

  svgImage.style.display = "none";
  svgImage.closest("svg").after(img);
});

// Watch for popup DOM insertion
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
